import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import AppLoading from "../components/AppLoading";

let loaderRoot = null;
let loaderContainer = null;
let pendingRequests = 0;

const ensureLoaderRoot = () => {
  if (loaderRoot && loaderContainer) return;

  loaderContainer = document.createElement("div");
  loaderContainer.id = "core-africa-global-loader";
  document.body.appendChild(loaderContainer);
  loaderRoot = createRoot(loaderContainer);
};

const showLoader = (message) => {
  ensureLoaderRoot();
  loaderRoot.render(<AppLoading message={message} />);
};

const hideLoader = () => {
  if (!loaderRoot || !loaderContainer) return;

  loaderRoot.unmount();
  document.body.removeChild(loaderContainer);
  loaderRoot = null;
  loaderContainer = null;
};

const initializeAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      pendingRequests += 1;
      showLoader("Processing request");
      return config;
    },
    (error) => Promise.reject(error)
  );

  const finalizeRequest = () => {
    pendingRequests = Math.max(pendingRequests - 1, 0);
    if (pendingRequests === 0) {
      hideLoader();
    }
  };

  axios.interceptors.response.use(
    (response) => {
      finalizeRequest();
      return response;
    },
    (error) => {
      finalizeRequest();
      return Promise.reject(error);
    }
  );
};

const initializeApp = () => {
  // Setting base URL for all API request via axios
  axios.defaults.baseURL =
    "https://core-africa-api-808279280637.europe-west1.run.app/";

  // Global axios interceptors to show loader for all API requests
  initializeAxiosInterceptors();

  // Show a short, graceful loading state during initial app boot
  // showLoader("Initializing system");
  window.setTimeout(() => {
    // Only hide if no in-flight requests
    if (pendingRequests === 0) {
      hideLoader();
    }
  }, 800);

  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    // dev code
  } else {
    // Prod build code
    // Removing console.log from prod
    // console.log = () => {};
    // init analytics here
  }
};

export default initializeApp;
